module.exports = __webpack_public_path__ + "img/gz_company.df55e359.png";